<template>
  <span
    :class="props.theme"
    class="arrow-button"
  >
    <SvgAsset
      :content="arrowSvg"
      class="icon"
    />
  </span>
</template>

<script lang="ts" setup>
  import type { PropType } from 'vue';
  import type { TTheme } from '~/components/ArrowMenu/ArrowMenu';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import arrowSvg from '~/assets/images/svg/arrow.svg?raw';

  const props = defineProps({
    theme: {
      type: String as PropType<TTheme>,
      required: true,
    },
  });
</script>

<style lang="scss" scoped>
  .arrow-button {
    height: 100%;
    width: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;

    @include tablet {
      padding: 0 12px;
      width: 48px;
    }

    @include big-tablet {
      width: 60px;
    }
  }

  .icon {
    height: 16px;
    width: 16px;
    display: none;

    @include tablet {
      display: block;
    }
  }

  .light {
    color: #969698;

    @include hover {
      color: black;
    }
  }

  .dark {
    color: #cccccc;

    @include hover {
      opacity: 0.6;
    }
  }
</style>
